import { useState } from "react";

const ToggleSwitch = ({ onChange, initialValue = true }) => {
    const [isYes, setIsYes] = useState(initialValue);

    const handleToggle = (value) => {
        setIsYes(value);
        if (onChange) onChange(value);
    };

    return (
        <div className={`toggle-switch ${isYes ? "yes" : "no"}`}>
            <button
                type="button"
                className={`toggle-btn no-btn ${!isYes ? "active" : ""}`}
                onClick={() => handleToggle(false)}
            >
                No
            </button>
            <button
                type="button"
                className={`toggle-btn yes-btn ${isYes ? "active" : ""}`}
                onClick={() => handleToggle(true)}
            >
                Yes
            </button>
        </div>
    );
};

export default ToggleSwitch;
